import React from 'react';
import { connect } from 'react-redux';
import {
  removeDraftFromQueue as removeDraftFromQueueAction,
} from '../supplier-updates-queue/__storeFiles__/actions';

const TextFlag = ({
  style = {},
  stagedUpdates = [],
  updateInitiated,
  removeDraftFromQueue,
  isEditedTemplate,
  isEditedDraft,
  refreshSection,
}) => {
  const stagedDraft = stagedUpdates.find(obj => obj.source === 'draft');
  const stagedPolicyNotes = stagedUpdates.find(obj => obj.source === 'policyNotes');
  if (updateInitiated) {
    return (
      <div style={style}>
        We are processing updates for this template.
      </div>
    );
  }
  return (
    <div style={{ color: refreshSection === 'list' ? 'red' : 'rgba(0, 0, 0, 0.67)', ...style }}>
      {stagedDraft && isEditedTemplate && (
        <div>
          This template has a{' '}
          <a
            style={{ cursor: 'pointer' }}
            href={`/contracting/draft/${stagedDraft.sourceId}/details`}
          >
            draft
          </a>{' '}
          queued for updates.&nbsp;
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer', color: 'rgba(0, 0, 0, 0.57)' }}
            onClick={e => {
              e.stopPropagation();
              removeDraftFromQueue(stagedDraft.sourceId, refreshSection);
            }}
          >
              Remove draft from queue {refreshSection === 'list' ? '' : 'to continue editing'}
            </span>
        </div>
      )}
      {stagedDraft && isEditedDraft && (
        <div>
          This draft has been queued for updates for this{' '}
          <a
            style={{ cursor: 'pointer' }}
            href={`/contracting/template/${stagedDraft.sourceId}/details`}
          >
            template
          </a>
          .
        </div>
      )}
      {stagedPolicyNotes && isEditedTemplate && (
        <div>
          This template has a{' '}
          <a
            style={{ cursor: 'pointer' }}
            href={`/contracting/master-template/${stagedPolicyNotes.sourceId}`}
          >
            Corporate Policies & Notes template
          </a>{' '}
          queued for updates.
        </div>
      )}
    </div>
  );
};

export default connect(null, { removeDraftFromQueue: removeDraftFromQueueAction })(TextFlag);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/template-staged-updates-text-flag.jsx